<div class="stepper-container" data-test="insurance-progress-stepper">
  <h4>Insurance overview:</h4>

  <div 
    *ngFor="let step of steps; let i=index" 
    class="step"
    [class.highlighted]="step.inProgress"
  >
    <div class="step-indicator">
      <div class="line" [class.hide-line]="i === 0"></div>
      
      <div class="circle">
        <iris-icon
          *ngIf="step.completed"
          name="check_circle"
          [size]="IconSizes.LG"
        ></iris-icon>
      </div>

      <div class="line" [class.hide-line]="i === steps.length-1"></div>
    </div>

    <div class="step-content" data-test="step-content">
      <p class="title" [class.not-completed]="!step.inProgress">{{ step.title }}</p>
      <p [class.not-completed]="!step.inProgress">{{ step.description }}</p>
    </div>
  </div>
</div>
